// Generated by purs version 0.13.0
"use strict";
var Chip_Model_Direction = require("../Chip.Model.Direction/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Show = require("../Data.Show/index.js");
var Bee = (function () {
    function Bee(value0) {
        this.value0 = value0;
    };
    Bee.create = function (value0) {
        return new Bee(value0);
    };
    return Bee;
})();
var Tank = (function () {
    function Tank(value0) {
        this.value0 = value0;
    };
    Tank.create = function (value0) {
        return new Tank(value0);
    };
    return Tank;
})();
var Ball = (function () {
    function Ball(value0) {
        this.value0 = value0;
    };
    Ball.create = function (value0) {
        return new Ball(value0);
    };
    return Ball;
})();
var FireBall = (function () {
    function FireBall(value0) {
        this.value0 = value0;
    };
    FireBall.create = function (value0) {
        return new FireBall(value0);
    };
    return FireBall;
})();
var Glider = (function () {
    function Glider(value0) {
        this.value0 = value0;
    };
    Glider.create = function (value0) {
        return new Glider(value0);
    };
    return Glider;
})();
var Teeth = (function () {
    function Teeth(value0) {
        this.value0 = value0;
    };
    Teeth.create = function (value0) {
        return new Teeth(value0);
    };
    return Teeth;
})();
var showEnemy = new Data_Show.Show(function (v) {
    if (v instanceof Bee) {
        return "Bee " + Data_Show.show(Chip_Model_Direction.showDirection)(v.value0);
    };
    if (v instanceof Tank) {
        return "Tank " + Data_Show.show(Chip_Model_Direction.showDirection)(v.value0);
    };
    if (v instanceof Ball) {
        return "#Ball " + Data_Show.show(Chip_Model_Direction.showDirection)(v.value0);
    };
    if (v instanceof FireBall) {
        return "FireBall " + Data_Show.show(Chip_Model_Direction.showDirection)(v.value0);
    };
    if (v instanceof Glider) {
        return "Glider " + Data_Show.show(Chip_Model_Direction.showDirection)(v.value0);
    };
    if (v instanceof Teeth) {
        return "Teeth " + Data_Show.show(Chip_Model_Direction.showDirection)(v.value0);
    };
    throw new Error("Failed pattern match at Chip.Model.Enemy (line 21, column 10 - line 27, column 50): " + [ v.constructor.name ]);
});
var eqEnemy = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Bee && y instanceof Bee) {
            return Data_Eq.eq(Chip_Model_Direction.eqDirection)(x.value0)(y.value0);
        };
        if (x instanceof Tank && y instanceof Tank) {
            return Data_Eq.eq(Chip_Model_Direction.eqDirection)(x.value0)(y.value0);
        };
        if (x instanceof Ball && y instanceof Ball) {
            return Data_Eq.eq(Chip_Model_Direction.eqDirection)(x.value0)(y.value0);
        };
        if (x instanceof FireBall && y instanceof FireBall) {
            return Data_Eq.eq(Chip_Model_Direction.eqDirection)(x.value0)(y.value0);
        };
        if (x instanceof Glider && y instanceof Glider) {
            return Data_Eq.eq(Chip_Model_Direction.eqDirection)(x.value0)(y.value0);
        };
        if (x instanceof Teeth && y instanceof Teeth) {
            return Data_Eq.eq(Chip_Model_Direction.eqDirection)(x.value0)(y.value0);
        };
        return false;
    };
});
module.exports = {
    Bee: Bee,
    Tank: Tank,
    Ball: Ball,
    FireBall: FireBall,
    Glider: Glider,
    Teeth: Teeth,
    eqEnemy: eqEnemy,
    showEnemy: showEnemy
};
